/* WWFS Collection Product Cards V7 - stable labels + unified fast pricing */
(function () {
  if (window.__wwfsCollectionCardsLoaded) return;
  window.__wwfsCollectionCardsLoaded = true;

  var pendingCardRoots = [];
  var cardInitFrame = null;
  var cardActionObserver = null;
  var cardActionTargets = new WeakMap();
  var productRequests = new Map();
  var observedFeefoWidgets = new WeakSet();
  var pendingFeefoWidgets = new Map();
  var feefoLoadingCheck = null;
  var wholesaleBadgeRequests = new Map();
  var wholesaleBadgeResults = new Map();
  var wholesaleBadgeQueue = Promise.resolve();
  var wholesaleBadgeObserver = null;
  var wholesaleBadgeTargets = new WeakMap();
  var cardImageObserver = null;

  function normaliseWholesaleBadgeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getWholesaleBadgeElements(card) {
    if (!card) return null;

    var layer = card.querySelector(
      '[data-wwfs-card-label-layer]'
    );
    var badge = layer
      ? layer.querySelector('[data-wwfs-wholesale-label]')
      : null;
    var text = badge
      ? badge.querySelector(
          '[data-wwfs-wholesale-label-text]'
        )
      : null;

    if (!layer || !badge || !text) return null;

    return {
      layer: layer,
      badge: badge,
      text: text
    };
  }

  function showWholesaleBadge(card, value) {
    var elements = getWholesaleBadgeElements(card);
    var text = normaliseWholesaleBadgeText(value);

    if (!elements || !text) return false;

    elements.text.textContent = text;
    elements.badge.hidden = false;
    elements.layer.classList.add('has-wholesale-badge');

    var visibleNativeLabels = 0;
    var maxNativeLabels = card.classList.contains(
      'card--has-ribbon'
    )
      ? 0
      : 1;

    elements.layer
      .querySelectorAll('.product-label-wrapper--native')
      .forEach(function (wrapper) {
        wrapper.classList.remove('wwfs-card-label-hidden');

        if (wrapper.hasAttribute('data-wwfs-native-sale-label')) {
          return;
        }

        visibleNativeLabels += 1;

        if (visibleNativeLabels > maxNativeLabels) {
          wrapper.classList.add('wwfs-card-label-hidden');
        }
      });

    return true;
  }

  function hideWholesaleBadge(card) {
    var elements = getWholesaleBadgeElements(card);

    if (!elements) return;

    elements.text.textContent = '';
    elements.badge.hidden = true;
    elements.layer.classList.remove('has-wholesale-badge');
    elements.layer
      .querySelectorAll('.wwfs-card-label-hidden')
      .forEach(function (wrapper) {
        wrapper.classList.remove('wwfs-card-label-hidden');
      });
  }

  function nativeVariantDiscountPercent(variant) {
    var price = Number(variant && variant.price);
    var compareAtPrice = Number(
      variant && variant.compare_at_price
    );

    if (
      !Number.isFinite(price) ||
      !Number.isFinite(compareAtPrice) ||
      price <= 0 ||
      compareAtPrice <= price
    ) {
      return 0;
    }

    return Math.max(
      0,
      Math.round(
        ((compareAtPrice - price) / compareAtPrice) * 100
      )
    );
  }

  function regularDiscountRule(result) {
    var discounts = result && result.regular_discounts;

    if (Array.isArray(discounts)) {
      return discounts.length ? discounts[0] : null;
    }

    return discounts || null;
  }

  function regularDiscountPercent(result, variant, basePrice) {
    var savedAmount = Number(result && result.ws_discount);

    if (!Number.isFinite(savedAmount) || savedAmount <= 0) {
      return nativeVariantDiscountPercent(variant);
    }

    var rule = regularDiscountRule(result);
    var productRule =
      result && result.product_regular_discount;
    var type = String(
      (rule && rule.type) ||
      (productRule && productRule.discount_type) ||
      ''
    ).toLowerCase();
    var value = Number(
      rule && rule.value !== undefined
        ? rule.value
        : productRule && productRule.discount_value
    );

    if (
      (type === 'percentage' ||
        type === 'percent' ||
        type === '%') &&
      Number.isFinite(value) &&
      value > 0
    ) {
      return Math.min(100, Math.max(0, Math.round(value)));
    }

    var divisor = Number(basePrice);

    if (!Number.isFinite(divisor) || divisor <= 0) {
      divisor = Number(variant && variant.price) / 100;
    }

    if (!Number.isFinite(divisor) || divisor <= 0) {
      return 0;
    }

    return Math.min(
      100,
      Math.max(0, Math.round((savedAmount / divisor) * 100))
    );
  }

  function hasUniformPercentageRule(result) {
    var savedAmount = Number(result && result.ws_discount);
    var rule = regularDiscountRule(result);
    var productRule =
      result && result.product_regular_discount;
    var type = String(
      (rule && rule.type) ||
      (productRule && productRule.discount_type) ||
      ''
    ).toLowerCase();
    var productSettings = productRule && productRule.product;
    var variantLevel =
      productSettings &&
      (productSettings.variant_level === true ||
        productSettings.variant_level === 'true');

    return Boolean(
      Number.isFinite(savedAmount) &&
      savedAmount > 0 &&
      (type === 'percentage' ||
        type === 'percent' ||
        type === '%') &&
      !variantLevel
    );
  }

  function resolveVariantRegularDiscount(product, variant) {
    return new Promise(function (resolve) {
      if (
        !window.WSAIO ||
        typeof window.WSAIO.regularDiscount !== 'function'
      ) {
        resolve({
          percent: nativeVariantDiscountPercent(variant),
          uniformPercentageRule: false
        });
        return;
      }

      var settled = false;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(null);
      }, 1200);

      try {
        var wsaio = window.WSAIO;
        var hasOwnGlobalCallback =
          Object.prototype.hasOwnProperty.call(
            wsaio,
            'callback'
          );
        var globalCallback = wsaio.callback;

        try {
          // WSAIO.regularDiscount also invokes WSAIO.callback. That
          // global hook is intended for cart/checkout calculations and
          // overwrites pre_checkout_data. Suppress only that hook while
          // this synchronous, output:false badge lookup runs.
          wsaio.callback = null;
          wsaio.regularDiscount(
            {
              template: 'collection',
              item_price_selector:
                document.createElement('span'),
              product_id: product.id,
              product_handle: product.handle,
              variant_id: variant.id,
              variant_sku: variant.sku || '',
              variant_price: variant.price,
              variant_compare_at_price:
                variant.compare_at_price || 0,
              collection_id: 'default',
              output: false
            },
            function (result) {
              if (settled) return;

              settled = true;
              window.clearTimeout(timeout);

              var basePrice = Number(
                wsaio.rd_or_regularPrice
              );

              resolve({
                percent: regularDiscountPercent(
                  result,
                  variant,
                  basePrice
                ),
                uniformPercentageRule:
                  hasUniformPercentageRule(result)
              });
            }
          );
        } finally {
          if (hasOwnGlobalCallback) {
            wsaio.callback = globalCallback;
          } else {
            delete wsaio.callback;
          }
        }
      } catch (error) {
        if (settled) return;

        settled = true;
        window.clearTimeout(timeout);
        resolve(null);
      }
    });
  }

  function aggregateVariantDiscounts(percentages) {
    if (!percentages.length) {
      return { percent: 0, text: '' };
    }

    var maximum = Math.max.apply(Math, percentages);

    if (!Number.isFinite(maximum) || maximum <= 0) {
      return { percent: 0, text: '' };
    }

    var first = percentages[0];
    var allEqual = percentages.every(function (percentage) {
      return percentage === first;
    });

    return {
      percent: maximum,
      text:
        (allEqual ? '' : 'Up to ') + maximum + '% off'
    };
  }

  /*
   * Resolve the one price that should be shown for a collection card.
   *
   * WSAIO returns both regular (Trade) and volume discount data from the
   * same productDiscount call. A qualifying volume tier takes priority;
   * otherwise the already-calculated regular discount is used. Keeping
   * this as a pure calculation also prevents WSAIO from replacing the
   * card's price markup with a differently-sized template later.
   */
  function resolveCollectionPriceState(
    response,
    variant,
    quantity,
    wsaio
  ) {
    var basePrice = Number(variant && variant.price) / 100;

    if (!Number.isFinite(basePrice) || basePrice <= 0) {
      return null;
    }

    var breaks = [];
    var volume = response && response.volume_discount;

    if (volume && Array.isArray(volume.quantity_breaks)) {
      breaks = volume.quantity_breaks;
    }

    if (
      volume &&
      volume.product_volume_discount &&
      Array.isArray(
        volume.product_volume_discount.volume_discount
      )
    ) {
      breaks =
        volume.product_volume_discount.volume_discount;
    }

    var qty = Math.max(1, Number(quantity) || 1);
    var activeBreak = null;

    breaks.forEach(function (tier) {
      var tierQty = Number(tier && tier.qty);

      if (
        Number.isFinite(tierQty) &&
        tierQty > 0 &&
        qty >= tierQty &&
        (!activeBreak || tierQty > Number(activeBreak.qty))
      ) {
        activeBreak = tier;
      }
    });

    if (
      activeBreak &&
      wsaio &&
      typeof wsaio.get_discount === 'function'
    ) {
      try {
        var tierDiscount = Number(
          wsaio.get_discount(
            basePrice,
            activeBreak.type,
            activeBreak.value
          )
        );
        var tierPrice = basePrice - tierDiscount;

        if (
          Number.isFinite(tierDiscount) &&
          tierDiscount > 0 &&
          Number.isFinite(tierPrice) &&
          tierPrice >= 0 &&
          tierPrice < basePrice
        ) {
          return {
            source: 'volume',
            current: tierPrice,
            original: basePrice
          };
        }
      } catch (error) {}
    }

    var regular = response && response.regular_discount;
    var regularSaved = Number(regular && regular.ws_discount);
    var regularPrice = basePrice - regularSaved;

    if (
      Number.isFinite(regularSaved) &&
      regularSaved > 0 &&
      Number.isFinite(regularPrice) &&
      regularPrice >= 0 &&
      regularPrice < basePrice
    ) {
      return {
        source: 'regular',
        current: regularPrice,
        original: basePrice
      };
    }

    return null;
  }

  function calculateWholesaleBadge(product) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant.available;
    });
    var percentages = [];

    function resolveNext(index) {
      if (index >= variants.length) {
        return Promise.resolve(
          aggregateVariantDiscounts(percentages)
        );
      }

      return resolveVariantRegularDiscount(
        product,
        variants[index]
      ).then(function (variantResult) {
        if (variantResult === null) return null;

        percentages.push(variantResult.percent);

        if (
          index === 0 &&
          variantResult.uniformPercentageRule
        ) {
          return aggregateVariantDiscounts(percentages);
        }

        return resolveNext(index + 1);
      });
    }

    return resolveNext(0);
  }

  function requestWholesaleBadge(productJsonUrl) {
    if (wholesaleBadgeRequests.has(productJsonUrl)) {
      return wholesaleBadgeRequests.get(productJsonUrl);
    }

    var request = loadProduct(productJsonUrl)
      .then(function (product) {
        var queuedRequest = wholesaleBadgeQueue
          .catch(function () {})
          .then(function () {
            return calculateWholesaleBadge(product);
          });

        wholesaleBadgeQueue = queuedRequest.catch(function () {});

        return queuedRequest;
      })
      .then(function (result) {
        wholesaleBadgeResults.set(productJsonUrl, result);
        return result;
      })
      .catch(function () {
        wholesaleBadgeResults.set(productJsonUrl, null);
        return null;
      });

    wholesaleBadgeRequests.set(productJsonUrl, request);
    return request;
  }

  function applyResolvedWholesaleBadge(card, result) {
    if (!card || !card.isConnected) return;

    if (result === null) {
      hideWholesaleBadge(card);
      return;
    }

    if (result.percent > 0 && result.text) {
      showWholesaleBadge(card, result.text);
    } else {
      hideWholesaleBadge(card);
    }
  }

  function connectionProfile() {
    var connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    return {
      saveData: Boolean(connection && connection.saveData),
      effectiveType: String(
        (connection && connection.effectiveType) || ''
      ).toLowerCase()
    };
  }

  function cardImagePrefetchMargin() {
    var profile = connectionProfile();

    if (
      profile.saveData ||
      profile.effectiveType === 'slow-2g' ||
      profile.effectiveType === '2g'
    ) {
      return 800;
    }

    return window.matchMedia('(max-width: 749px)').matches
      ? 900
      : 1600;
  }

  function wholesaleBadgePrefetchMargin() {
    var profile = connectionProfile();

    if (
      profile.saveData ||
      profile.effectiveType === 'slow-2g' ||
      profile.effectiveType === '2g'
    ) {
      return 450;
    }

    return window.matchMedia('(max-width: 749px)').matches
      ? 1200
      : 900;
  }

  function setResponsiveImageSources(img) {
    if (!img) return;

    var setAttrs = function (element) {
      if (!element) return;

      if (element.dataset && element.dataset.srcset && !element.srcset) {
        element.srcset = element.dataset.srcset;
      }

      if (
        element.dataset &&
        element.dataset.src &&
        (!element.getAttribute('src') ||
          String(element.getAttribute('src')).indexOf('data:image/svg+xml') === 0)
      ) {
        element.src = element.dataset.src;
      }
    };

    if (img.parentNode && img.parentNode.tagName === 'PICTURE') {
      Array.from(img.parentNode.children).forEach(setAttrs);
    } else {
      setAttrs(img);
    }
  }

  function sizeCardImage(img) {
    var width = Math.ceil(img.getBoundingClientRect().width);
    if (width > 0) img.sizes = width + 'px';
  }

  var cardImageSizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { sizeCardImage(entry.target); });
      })
    : null;

  function promoteCardImage(img) {
    if (!img || img.dataset.wwfsImagePromoted === 'true') return;

    sizeCardImage(img);
    if (cardImageSizeObserver) cardImageSizeObserver.observe(img);
    img.dataset.wwfsImagePromoted = 'true';
    img.loading = 'eager';
    img.fetchPriority = 'auto';
    setResponsiveImageSources(img);
  }

  function getCardImageObserver() {
    if (
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window)
    ) {
      return null;
    }

    if (cardImageObserver) return cardImageObserver;

    cardImageObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.target.isConnected) {
            cardImageObserver.unobserve(entry.target);
            return;
          }

          if (!entry.isIntersecting) return;

          cardImageObserver.unobserve(entry.target);
          promoteCardImage(entry.target);
        });
      },
      {
        rootMargin: cardImagePrefetchMargin() + 'px 0px',
        threshold: 0
      }
    );

    return cardImageObserver;
  }

  function registerCardImages(root) {
    if (!root) return;

    var selector = 'img[data-wwfs-prefetch-image]';
    var images = [];

    if (root.nodeType === 1 && root.matches(selector)) {
      images.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      images = images.concat(
        Array.from(root.querySelectorAll(selector))
      );
    }

    var observer = getCardImageObserver();

    images.forEach(function (img) {
      if (img.dataset.wwfsImageObserved === 'true') return;

      if (!observer) {
        promoteCardImage(img);
        return;
      }

      img.dataset.wwfsImageObserved = 'true';
      observer.observe(img);
    });
  }

  function unregisterCardImages(root) {
    if (!root || !cardImageObserver) return;

    var selector = 'img[data-wwfs-prefetch-image]';
    var images = [];

    if (root.nodeType === 1 && root.matches(selector)) {
      images.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      images = images.concat(
        Array.from(root.querySelectorAll(selector))
      );
    }

    images.forEach(function (img) {
      cardImageObserver.unobserve(img);
      if (cardImageSizeObserver) cardImageSizeObserver.unobserve(img);
      delete img.dataset.wwfsImageObserved;
    });
  }

  function resolveWholesaleBadge(card, productJsonUrl) {
    if (!card || !productJsonUrl) return;

    requestWholesaleBadge(productJsonUrl).then(function (result) {
      applyResolvedWholesaleBadge(card, result);
    });
  }

  function getWholesaleBadgeObserver() {
    if (
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window)
    ) {
      return null;
    }

    if (wholesaleBadgeObserver) return wholesaleBadgeObserver;

    wholesaleBadgeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;

          if (!card.isConnected) {
            wholesaleBadgeObserver.unobserve(card);
            wholesaleBadgeTargets.delete(card);
            return;
          }

          if (!entry.isIntersecting) return;

          var productJsonUrl = wholesaleBadgeTargets.get(card);

          wholesaleBadgeObserver.unobserve(card);
          wholesaleBadgeTargets.delete(card);
          delete card.dataset.wwfsWholesaleObserved;

          if (productJsonUrl) {
            resolveWholesaleBadge(card, productJsonUrl);
          }
        });
      },
      {
        rootMargin: wholesaleBadgePrefetchMargin() + 'px 0px',
        threshold: 0
      }
    );

    return wholesaleBadgeObserver;
  }

  function registerWholesaleBadgeTarget(card, productJsonUrl) {
    if (!card || !productJsonUrl) return;

    var observer = getWholesaleBadgeObserver();

    if (!observer) {
      resolveWholesaleBadge(card, productJsonUrl);
      return;
    }

    if (card.dataset.wwfsWholesaleObserved === 'true') return;

    card.dataset.wwfsWholesaleObserved = 'true';
    wholesaleBadgeTargets.set(card, productJsonUrl);
    observer.observe(card);
  }

  function unregisterWholesaleBadgeTarget(card) {
    if (!card || !wholesaleBadgeObserver) return;

    if (card.dataset.wwfsWholesaleObserved === 'true') {
      wholesaleBadgeObserver.unobserve(card);
      wholesaleBadgeTargets.delete(card);
      delete card.dataset.wwfsWholesaleObserved;
    }
  }

  function unregisterWholesaleBadgeTargets(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.matches('product-card.card--product')) {
      unregisterWholesaleBadgeTarget(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root
        .querySelectorAll('product-card.card--product')
        .forEach(unregisterWholesaleBadgeTarget);
    }
  }

  function captureWholesaleBadge(wrapper) {
    if (
      !wrapper ||
      !wrapper.parentElement ||
      !wrapper.matches('.product-label-wrapper.flex') ||
      !wrapper.querySelector('.product-label--sale') ||
      !wrapper.parentElement.matches(
        'product-card.card--product'
      )
    ) {
      return;
    }

    var card = wrapper.parentElement;
    var productJsonUrl = card.dataset.wwfsProductJsonUrl;

    if (!getWholesaleBadgeElements(card)) return;

    if (productJsonUrl && wholesaleBadgeResults.has(productJsonUrl)) {
      applyResolvedWholesaleBadge(
        card,
        wholesaleBadgeResults.get(productJsonUrl)
      );
    } else {
      hideWholesaleBadge(card);
    }

    wrapper.remove();

    if (!productJsonUrl) return;

    registerWholesaleBadgeTarget(card, productJsonUrl);
  }

  function registerWholesaleBadges(root) {
    if (!root) return;

    var selector =
      'product-card.card--product > .product-label-wrapper.flex';
    var wrappers = [];

    if (root.nodeType === 1 && root.matches(selector)) {
      wrappers.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      wrappers = wrappers.concat(
        Array.from(root.querySelectorAll(selector))
      );
    }

    wrappers.forEach(captureWholesaleBadge);
  }

  function addFeefoCardStyles(widget) {
    var root = widget.shadowRoot;
    if (!root) return false;

    if (!root.querySelector('#wwfs-feefo-card-styles')) {
      var style = document.createElement('style');
      style.id = 'wwfs-feefo-card-styles';
      style.textContent = [
        ':host {',
        '  display: inline-flex !important;',
        '  align-items: center !important;',
        '  flex-wrap: nowrap !important;',
        '  flex: 0 0 auto !important;',
        '  width: max-content !important;',
        '  white-space: nowrap !important;',
        '}',
        '.reviews-count {',
        '  display: inline-block !important;',
        '  flex: 0 0 auto !important;',
        '  white-space: nowrap !important;',
        '}',
        'svg {',
        '  width: var(--wwfs-feefo-star-desktop, 12px) !important;',
        '  height: var(--wwfs-feefo-star-desktop, 12px) !important;',
        '  min-width: var(--wwfs-feefo-star-desktop, 12px) !important;',
        '}',
        '@media (max-width: 749px) {',
        '  svg {',
        '    width: var(--wwfs-feefo-star-mobile, 10px) !important;',
        '    height: var(--wwfs-feefo-star-mobile, 10px) !important;',
        '    min-width: var(--wwfs-feefo-star-mobile, 10px) !important;',
        '  }',
        '}'
      ].join('\n');
      root.appendChild(style);
    }

    var countElement = root.querySelector('.reviews-count');

    if (countElement) {
      var currentElement = countElement;

      while (currentElement && currentElement !== root) {
        currentElement.style.setProperty(
          'white-space',
          'nowrap',
          'important'
        );
        currentElement.style.setProperty(
          'flex-wrap',
          'nowrap',
          'important'
        );
        currentElement = currentElement.parentElement;
      }
    }

    return true;
  }

  function updateFeefoReviewLabel(widget) {
    var root = widget.shadowRoot;
    if (!root) return false;

    addFeefoCardStyles(widget);

    var countElement = root.querySelector('.reviews-count');
    if (!countElement) return false;

    var match = countElement.textContent
      .trim()
      .match(/^\(\s*([\d,]+)(?:\s+reviews?)?\s*\)$/i);

    if (!match) return false;

    var displayedNumber = match[1];
    var total = Number(displayedNumber.replace(/,/g, ''));
    var label = total === 1 ? 'review' : 'reviews';
    var newText =
      '(' + displayedNumber + ' ' + label + ')';

    if (countElement.textContent.trim() !== newText) {
      countElement.textContent = newText;
    }

    countElement.setAttribute(
      'aria-label',
      displayedNumber + ' ' + label
    );

    return true;
  }

  function connectFeefoWidget(widget) {
    if (observedFeefoWidgets.has(widget)) return true;
    if (!widget.shadowRoot) return false;

    updateFeefoReviewLabel(widget);

    observedFeefoWidgets.add(widget);

    new MutationObserver(function () {
      updateFeefoReviewLabel(widget);
    }).observe(widget.shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    return true;
  }

  function startFeefoLoadingCheck() {
    if (feefoLoadingCheck !== null) return;

    feefoLoadingCheck = window.setInterval(function () {
      pendingFeefoWidgets.forEach(function (attempts, widget) {
        if (!widget.isConnected) {
          pendingFeefoWidgets.delete(widget);
          return;
        }

        if (connectFeefoWidget(widget)) {
          pendingFeefoWidgets.delete(widget);
          return;
        }

        if (attempts >= 49) {
          pendingFeefoWidgets.delete(widget);
        } else {
          pendingFeefoWidgets.set(widget, attempts + 1);
        }
      });

      if (pendingFeefoWidgets.size === 0) {
        window.clearInterval(feefoLoadingCheck);
        feefoLoadingCheck = null;
      }
    }, 200);
  }

  function registerFeefoWidget(widget) {
    if (
      observedFeefoWidgets.has(widget) ||
      connectFeefoWidget(widget)
    ) {
      pendingFeefoWidgets.delete(widget);
      return;
    }

    pendingFeefoWidgets.set(widget, 0);
    startFeefoLoadingCheck();
  }

  function registerFeefoWidgets(root) {
    if (!root) return;

    var selector =
      '.wwfs-card-rating .feefo-product-stars-widget';
    var widgets = [];

    if (
      root.nodeType === 1 &&
      root.matches(selector)
    ) {
      widgets.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      widgets = widgets.concat(
        Array.from(root.querySelectorAll(selector))
      );
    }

    widgets.forEach(registerFeefoWidget);
  }

  function initFeefoCards() {
    registerFeefoWidgets(document);
    registerWholesaleBadges(document);

    if (window.__wwfsFeefoCardObserver) return;
    window.__wwfsFeefoCardObserver = true;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            registerFeefoWidgets(node);
            registerWholesaleBadges(node);
            registerCardImages(node);
            queueWWFSCardActions(node);
          }
        });

        mutation.removedNodes.forEach(function (node) {
          unregisterCardActionTargets(node);
          unregisterWholesaleBadgeTargets(node);
          unregisterCardImages(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function rootContainsCardActions(root) {
    if (!root) return false;

    if (
      root.nodeType === 1 &&
      root.matches('.wwfs-card-actions')
    ) {
      return true;
    }

    return (
      typeof root.querySelector === 'function' &&
      root.querySelector('.wwfs-card-actions') !== null
    );
  }

  function queueWWFSCardActions(root) {
    if (!rootContainsCardActions(root)) return;

    pendingCardRoots.push(root);

    if (cardInitFrame !== null) return;

    cardInitFrame = window.requestAnimationFrame(function () {
      var roots = pendingCardRoots;

      pendingCardRoots = [];
      cardInitFrame = null;

      roots.forEach(function (queuedRoot) {
        initWWFSCardActions(queuedRoot);
      });
    });
  }

  function observeCollectionChanges() {
    document
      .querySelectorAll('.cc-collection-products')
      .forEach(function (section) {
        if (section.dataset.wwfsLayoutObserver === 'true') {
          return;
        }

        section.dataset.wwfsLayoutObserver = 'true';

        new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              registerCardImages(node);
              queueWWFSCardActions(node);
            });

            mutation.removedNodes.forEach(function (node) {
              unregisterCardActionTargets(node);
              unregisterWholesaleBadgeTargets(node);
              unregisterCardImages(node);
            });
          });
        }).observe(section, {
          childList: true,
          subtree: true
        });
      });
  }
  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /*
   * Request a suitably sized image from Shopify's CDN.
   * This avoids loading the original full-resolution image.
   */
  function shopifyImageUrl(src, width) {
    if (!src) return '';

    try {
      var url = new URL(src, window.location.origin);

      url.searchParams.set('width', String(width));

      return url.toString();
    } catch (error) {
      var separator = src.indexOf('?') === -1 ? '?' : '&';

      return src + separator + 'width=' + width;
    }
  }

  /*
   * Responsive image candidates for collection product cards.
   */
  function shopifyImageSrcset(src) {
    return [
      shopifyImageUrl(src, 320) + ' 320w',
      shopifyImageUrl(src, 480) + ' 480w',
      shopifyImageUrl(src, 640) + ' 640w'
    ].join(', ');
  }

  function isColourOption(name) {
    var n = String(name || '').toLowerCase();

    return n === 'colour' || n === 'color';
  }

  function loadProduct(productJsonUrl) {
    if (productRequests.has(productJsonUrl)) {
      return productRequests.get(productJsonUrl);
    }

    var request = fetch(productJsonUrl)
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Unable to load product');
        }

        return res.json();
      })
      .catch(function (error) {
        if (productRequests.get(productJsonUrl) === request) {
          productRequests.delete(productJsonUrl);
        }

        throw error;
      });

    productRequests.set(productJsonUrl, request);
    return request;
  }

  function showProductFallback(holder) {
    if (holder.querySelector('.wwfs-direct-fallback')) return;

    var link = document.createElement('a');

    link.className = 'wwfs-direct-fallback';
    link.href = holder.dataset.productUrl;
    link.textContent = 'View product';
    holder.appendChild(link);
  }

  function hydrateCardActions(holder) {
    if (
      holder.dataset.wwfsReady === 'true' ||
      holder.dataset.wwfsHydrating === 'true'
    ) {
      return;
    }

    var handle = holder.dataset.productHandle;
    var productJsonUrl = holder.dataset.productJsonUrl ||
      (handle ? '/products/' + encodeURIComponent(handle) + '.js' : '');

    if (!productJsonUrl) return;

    holder.dataset.wwfsHydrating = 'true';
    delete holder.dataset.wwfsObserved;

    loadProduct(productJsonUrl)
      .then(function (product) {
        if (!holder.isConnected) {
          delete holder.dataset.wwfsHydrating;
          return;
        }

        buildActions(holder, product);
        holder.dataset.wwfsReady = 'true';
        delete holder.dataset.wwfsFailed;
      })
      .catch(function () {
        if (!holder.isConnected) return;

        holder.dataset.wwfsFailed = 'true';
        showProductFallback(holder);
      })
      .finally(function () {
        delete holder.dataset.wwfsHydrating;
      });
  }

  function getCardActionObserver() {
    if (
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window)
    ) {
      return null;
    }

    if (cardActionObserver) return cardActionObserver;

    cardActionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.target.isConnected) {
          unregisterCardActionTarget(entry.target);
          return;
        }

        if (!entry.isIntersecting) return;

        var holders = cardActionTargets.get(entry.target);

        cardActionObserver.unobserve(entry.target);
        cardActionTargets.delete(entry.target);

        if (!entry.target.isConnected) {
          if (holders) {
            holders.forEach(function (holder) {
              delete holder.dataset.wwfsObserved;
            });
          }
          return;
        }

        if (holders) {
          holders.forEach(hydrateCardActions);
        }
      });
    }, {
      rootMargin: '1000px 0px',
      threshold: 0
    });

    return cardActionObserver;
  }

  function unregisterCardActionTarget(target) {
    if (!target || !cardActionTargets.has(target)) return;

    var holders = cardActionTargets.get(target);

    if (cardActionObserver) {
      cardActionObserver.unobserve(target);
    }

    if (holders) {
      holders.forEach(function (holder) {
        delete holder.dataset.wwfsObserved;
      });
    }

    cardActionTargets.delete(target);
  }

  function unregisterCardActionTargets(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.matches('.card')) {
      unregisterCardActionTarget(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('.card').forEach(unregisterCardActionTarget);
    }
  }

  function registerCardActions(holder) {
    if (
      holder.dataset.wwfsReady === 'true' ||
      holder.dataset.wwfsHydrating === 'true' ||
      holder.dataset.wwfsObserved === 'true'
    ) {
      return;
    }

    if (holder.dataset.wwfsClickGuard !== 'true') {
      holder.dataset.wwfsClickGuard = 'true';

      /*
       * The theme makes the whole product card clickable. Keep clicks on
       * variant, quantity and Add to Cart controls inside this component
       * so they can never trigger the product-card navigation handler.
       */
      holder.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    var observer = getCardActionObserver();
    var target = holder.closest('.card');

    if (!observer || !target) {
      hydrateCardActions(holder);
      return;
    }

    var holders = cardActionTargets.get(target);

    if (!holders) {
      holders = new Set();
      cardActionTargets.set(target, holders);
      observer.observe(target);
    }

    holders.add(holder);
    holder.dataset.wwfsObserved = 'true';
  }

  function initWWFSCardActions(root) {
    var searchRoot = root || document;
    var holders = [];

    if (
      searchRoot.nodeType === 1 &&
      searchRoot.matches('.wwfs-card-actions')
    ) {
      holders.push(searchRoot);
    }

    if (typeof searchRoot.querySelectorAll === 'function') {
      holders = holders.concat(
        Array.from(
          searchRoot.querySelectorAll('.wwfs-card-actions')
        )
      );
    }

    holders.forEach(registerCardActions);
  }

  function buildActions(holder, product) {
    var card = holder.closest('.card');

    var inventoryByVariant = {};
    var inventoryJson = holder.querySelector(
      '.wwfs-variant-inventory-json'
    );

    if (inventoryJson) {
      try {
        JSON.parse(inventoryJson.textContent).forEach(function (item) {
          inventoryByVariant[String(item.id)] = item;
        });
      } catch (error) {}
    }

    var priceEl = card
      ? card.querySelector(
          '.price, .price--bottom, .price--top, .card__price'
        )
      : null;

    var inventoryEl = card
      ? card.querySelector('.product-inventory__status')
      : null;

    if (!inventoryEl && card && priceEl) {
      inventoryEl = document.createElement('div');
      inventoryEl.className =
        'product-inventory__status wwfs-variant-inventory';
      inventoryEl.setAttribute('role', 'status');
      inventoryEl.setAttribute('aria-live', 'polite');

      var priceRow = priceEl.closest('.flex.grow.items-end');

      if (priceRow && priceRow.parentNode) {
        priceRow.parentNode.insertBefore(inventoryEl, priceRow.nextSibling);
      } else if (priceEl.parentNode) {
        priceEl.parentNode.insertBefore(
          inventoryEl,
          priceEl.nextSibling
        );
      }
    }

    if (inventoryEl) {
      inventoryEl.classList.add('wwfs-variant-inventory');
      inventoryEl.setAttribute('role', 'status');
      inventoryEl.setAttribute('aria-live', 'polite');
    }

    var savingEl = null;
    var singleVariant = product.variants.length === 1;
    var productName = product.title || 'product';
    var priceRequestId = 0;

    var formId =
      'wwfs-card-form-' +
      product.id +
      '-' +
      Math.random().toString(36).slice(2);

    var initialVariant =
      product.variants.find(function (variant) {
        return variant.available;
      }) || product.variants[0];

    var selected = initialVariant
      ? initialVariant.options.slice()
      : product.options.map(function (option) {
          return option.values[0];
        });

    function getVariant() {
      if (singleVariant) {
        return product.variants[0];
      }

      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      });
    }

    function getVariantForOptionValue(optionIndex, value) {
      return (
        product.variants.find(function (variant) {
          return (
            variant.options[optionIndex] === value &&
            variant.featured_image &&
            variant.featured_image.src
          );
        }) ||
        product.variants.find(function (variant) {
          return variant.options[optionIndex] === value;
        })
      );
    }

    /*
     * Only called after a customer actively selects an option.
     *
     * A 640px fallback image is supplied alongside a responsive
     * srcset, allowing the browser to choose the most suitable size.
     */
    function updateCardImage(variant) {
      if (
        !card ||
        !variant ||
        !variant.featured_image ||
        !variant.featured_image.src
      ) {
        return;
      }

      var img = card.querySelector(
        '.card__media img.card__main-image, .card__media img'
      );

      if (!img) return;

      var originalSrc = variant.featured_image.src;

      if (variant.featured_image.width) {
        img.width = variant.featured_image.width;
      }

      if (variant.featured_image.height) {
        img.height = variant.featured_image.height;
      }

      if (variant.featured_image.alt) {
        img.alt = variant.featured_image.alt;
      }

      /*
       * Give the browser responsive sizing information before the fallback
       * URL. This avoids starting an unnecessary 640px request before it
       * has a chance to select the 320px or 480px candidate.
       */
      sizeCardImage(img);
      if (cardImageSizeObserver) cardImageSizeObserver.observe(img);

      img.srcset = shopifyImageSrcset(originalSrc);
      img.src = shopifyImageUrl(originalSrc, 640);
    }

    function renderNormalPrice(variant) {
      if (!priceEl || !variant) return;

      var compare =
        variant.compare_at_price &&
        variant.compare_at_price > variant.price;

      priceEl.innerHTML =
        '<strong class="price__current">' +
        money(variant.price) +
        '</strong>' +
        (compare
          ? ' <s class="price__was">' +
            money(variant.compare_at_price) +
            '</s>'
          : '');
    }

    function renderDiscountedPrice(
      variant,
      discountedPrice,
      originalPrice
    ) {
      if (!priceEl || !variant) return;

      priceEl.innerHTML =
        '<strong class="price__current">' +
        discountedPrice +
        '</strong>' +
        ' <s class="price__was">' +
        originalPrice +
        '</s>';

      if (savingEl) {
        savingEl.textContent = '';
      }
    }

    function updateInventory(variant) {
      if (!inventoryEl) return;

      inventoryEl.classList.remove(
        'is-out-of-stock',
        'is-available-to-order'
      );

      if (!variant) {
        inventoryEl.textContent = 'Unavailable';
        inventoryEl.classList.add('is-out-of-stock');
        inventoryEl.dataset.inventoryLevel = 'none';
        return;
      }

      var inventory = inventoryByVariant[String(variant.id)];

      if (!variant.available) {
        inventoryEl.textContent = 'Out of stock';
        inventoryEl.classList.add('is-out-of-stock');
        inventoryEl.dataset.inventoryLevel = 'none';
        return;
      }

      if (
        inventory &&
        inventory.management &&
        inventory.policy === 'continue' &&
        Number(inventory.quantity) <= 0
      ) {
        inventoryEl.textContent = 'Available to order';
        inventoryEl.classList.add('is-available-to-order');
        inventoryEl.dataset.inventoryLevel = 'backordered';
        return;
      }

      if (
        inventory &&
        inventory.management &&
        Number(inventory.quantity) > 0
      ) {
        var quantity = Number(inventory.quantity);

        inventoryEl.textContent =
          'In stock (' +
          quantity +
          (quantity === 1 ? ' unit)' : ' units)');
      } else {
        inventoryEl.textContent = 'In stock';
      }

      inventoryEl.dataset.inventoryLevel = 'normal';
    }

    function applyWholesaleTierPrice(variant, requestId) {
      if (!variant || !priceEl) return;

      if (
        !window.WSAIO ||
        typeof window.WSAIO.productDiscount !== 'function'
      ) {
        if (savingEl) {
          savingEl.textContent = '';
        }

        renderNormalPrice(variant);
        return;
      }

      var qtyInput = holder.querySelector('.wwfs-qty-input');

      var qty = Math.max(
        1,
        Number(qtyInput ? qtyInput.value || 1 : 1)
      );

      try {
        var wsaio = window.WSAIO;
        var hasOwnGlobalCallback =
          Object.prototype.hasOwnProperty.call(
            wsaio,
            'callback'
          );
        var globalCallback = wsaio.callback;

        try {
          /*
           * productDiscount also invokes WSAIO.callback. That global hook
           * is for checkout/cart calculations and overwrites
           * pre_checkout_data. Suppress only that hook while this
           * synchronous output:false card-price lookup runs.
           */
          wsaio.callback = null;
          wsaio.productDiscount(
            {
              template: 'collection',
              item_price_selector: priceEl,
              product_id: product.id,
              product_handle: product.handle,
              variant_id: variant.id,
              variant_sku: variant.sku || '',
              variant_price: variant.price,
              variant_compare_at_price:
                variant.compare_at_price || 0,
              collection_id: 'default',
              output: false,
              apply_volume_discount: true
            },
            function (response) {
              if (requestId !== priceRequestId) return;

              var priceState = resolveCollectionPriceState(
                response,
                variant,
                qty,
                wsaio
              );

              if (!priceState) {
                renderNormalPrice(variant);
                return;
              }

              var formatMoney =
                typeof wsaio.formatMoney === 'function'
                  ? function (value) {
                      return wsaio.formatMoney(value);
                    }
                  : function (value) {
                      return money(Math.round(value * 100));
                    };

              renderDiscountedPrice(
                variant,
                formatMoney(priceState.current),
                formatMoney(priceState.original)
              );
            }
          );
        } finally {
          if (hasOwnGlobalCallback) {
            wsaio.callback = globalCallback;
          } else {
            delete wsaio.callback;
          }
        }
      } catch (error) {
        if (requestId === priceRequestId) {
          renderNormalPrice(variant);
        }
      }
    }

    var html = '<div class="wwfs-direct-buy">';

    if (!singleVariant) {
      product.options.forEach(function (
        option,
        optionIndex
      ) {
        var colourOption = isColourOption(option.name);

        html +=
          '<div class="wwfs-direct-option' +
          (colourOption
            ? ' wwfs-direct-option--colour'
            : '') +
          '">';

        html +=
          '<div class="wwfs-direct-label" data-colour-label="' +
          optionIndex +
          '">' +
          esc(option.name) +
          (colourOption
            ? ': ' + esc(selected[optionIndex])
            : '') +
          '</div>';

        html +=
          '<div class="wwfs-direct-scroll' +
          (colourOption
            ? ' wwfs-direct-scroll--swatches'
            : '') +
          '" role="group" aria-label="' +
          esc(option.name) +
          ' options for ' +
          esc(productName) +
          '">';

        option.values.forEach(function (
          value,
          valueIndex
        ) {
          var variantForValue =
            getVariantForOptionValue(optionIndex, value);

          var originalSwatchImage =
            variantForValue &&
            variantForValue.featured_image &&
            variantForValue.featured_image.src
              ? variantForValue.featured_image.src
              : '';

          /*
           * Swatches only need a very small image.
           * Request a 120px version rather than the original.
           */
          var swatchImage = originalSwatchImage
            ? shopifyImageUrl(originalSwatchImage, 120)
            : '';

          if (colourOption && swatchImage) {
            html +=
              '<button type="button" title="' +
              esc(value) +
              '" aria-label="Select ' +
              esc(option.name) +
              ': ' +
              esc(value) +
              ' for ' +
              esc(productName) +
              '" aria-pressed="' +
              (selected[optionIndex] === value ? 'true' : 'false') +
              '" class="wwfs-direct-chip wwfs-colour-chip' +
              (selected[optionIndex] === value ? ' is-active' : '') +
              '" data-option-index="' +
              optionIndex +
              '" data-value="' +
              esc(value) +
              '">';

            html +=
              '<span aria-hidden="true" style="background-image:url(\'' +
              esc(swatchImage) +
              '\')"></span>';

            html += '</button>';
          } else {
            html +=
              '<button type="button" aria-label="Select ' +
              esc(option.name) +
              ': ' +
              esc(value) +
              ' for ' +
              esc(productName) +
              '" aria-pressed="' +
              (selected[optionIndex] === value ? 'true' : 'false') +
              '" class="wwfs-direct-chip' +
              (selected[optionIndex] === value ? ' is-active' : '') +
              '" data-option-index="' +
              optionIndex +
              '" data-value="' +
              esc(value) +
              '">' +
              esc(value) +
              '</button>';
          }
        });

        html += '</div></div>';
      });
    }

    html += '<div class="wwfs-direct-footer">';

    html +=
      '<div class="wwfs-direct-qty" role="group" aria-label="Quantity controls for ' +
      esc(productName) +
      '">';

    html +=
      '<button type="button" class="wwfs-qty-minus" aria-label="Decrease quantity for ' +
      esc(productName) +
      '">−</button>';

    html +=
      '<input class="wwfs-qty-input" type="number" min="1" step="1" value="1" inputmode="numeric" aria-label="Quantity for ' +
      esc(productName) +
      '">';

    html +=
      '<button type="button" class="wwfs-qty-plus" aria-label="Increase quantity for ' +
      esc(productName) +
      '">+</button>';

    html += '</div>';

    html +=
      '<button type="button" class="wwfs-direct-add" aria-label="Add ' +
      esc(productName) +
      ' to cart">' +
      '<svg class="wwfs-direct-add__icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M17 18a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1V2m6 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7 2.78-5H6.14l2.36 5H16Z"/>' +
      '</svg>' +
      '<span>Add to cart</span>' +
      '</button>';

    html += '</div>';

    html +=
      '<product-form class="wwfs-native-product-form" style="display:none;">';

    html +=
      '<form method="post" action="/cart/add" id="' +
      formId +
      '" accept-charset="UTF-8" class="js-product-form" enctype="multipart/form-data" novalidate="novalidate">';

    html +=
      '<input type="hidden" name="form_type" value="product">';

    html +=
      '<input type="hidden" name="utf8" value="✓">';

    html +=
      '<input type="hidden" name="id" class="wwfs-native-variant-id" value="">';

    html +=
      '<input type="hidden" name="quantity" class="wwfs-native-quantity" value="1">';

    html +=
      '<div class="alert mb-8 bg-error-bg text-error-text js-form-error text-start" role="alert" hidden></div>';

    html +=
      '<button type="submit" name="add" class="wwfs-native-submit">Add to cart</button>';

    html += '</form>';
    html += '</product-form>';

    html +=
      '<div class="wwfs-direct-saving" hidden></div>';

    html += '</div>';

    holder.innerHTML = html;

    var addBtn = holder.querySelector(
      '.wwfs-direct-add'
    );

    var directBuy = holder.querySelector(
      '.wwfs-direct-buy'
    );

    var directQty = holder.querySelector(
      '.wwfs-direct-qty'
    );

    var qtyInput = holder.querySelector(
      '.wwfs-qty-input'
    );

    var nativeForm = holder.querySelector(
      '.wwfs-native-product-form form'
    );

    var nativeProductForm = holder.querySelector(
      '.wwfs-native-product-form'
    );

    var nativeVariantInput = holder.querySelector(
      '.wwfs-native-variant-id'
    );

    var nativeQtyInput = holder.querySelector(
      '.wwfs-native-quantity'
    );

    var nativeSubmit = holder.querySelector(
      '.wwfs-native-submit'
    );

    savingEl = holder.querySelector(
      '.wwfs-direct-saving'
    );

    /*
     * WSAIO's legacy collection click handler is attached after these
     * controls and waits 1.5 seconds before fetching the same product and
     * recalculating it several times. The controls already perform the one
     * required calculation below, so stop only that redundant bubble path.
     * Native Add to Cart runs on its button before the event reaches this
     * wrapper and is therefore unchanged.
     */
    if (directQty) {
      directQty.addEventListener('click', function (event) {
        event.stopImmediatePropagation();
      });
    }

    if (directBuy) {
      directBuy.addEventListener('click', function (event) {
        event.stopImmediatePropagation();
      });
    }

    function updateLabels() {
      product.options.forEach(function (
        option,
        optionIndex
      ) {
        if (!isColourOption(option.name)) return;

        var label = holder.querySelector(
          '[data-colour-label="' +
            optionIndex +
            '"]'
        );

        if (label) {
          label.textContent =
            option.name + ': ' + selected[optionIndex];
        }
      });
    }

    function syncActiveChips() {
      holder
        .querySelectorAll('.wwfs-direct-chip')
        .forEach(function (chip) {
          var index = Number(chip.dataset.optionIndex);
          var active = selected[index] === chip.dataset.value;

          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    /*
     * updateImage should only be true when a customer
     * actively clicks a variant option.
     */
    function update(updateImage, retainCurrentPrice) {
      var variant = getVariant();

      updateLabels();

      if (!variant) {
        priceRequestId += 1;
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';

        if (priceEl) {
          priceEl.innerHTML =
            '<strong class="price__current">Unavailable</strong>';
        }

        updateInventory(null);

        return;
      }

      addBtn.dataset.variantId = variant.id;

      if (nativeVariantInput) {
        nativeVariantInput.value = variant.id;
      }

      if (nativeQtyInput) {
        nativeQtyInput.value = Math.max(
          1,
          Number(qtyInput.value || 1)
        );
      }

      /*
       * Quantity changes retain the price currently on screen while the
       * wholesale app calculates the next tier. This prevents the standard
       * price flashing briefly between two valid multibuy prices.
       *
       * Variant changes still render their own standard price immediately,
       * so a newly selected variant can never show the previous variant's
       * price while its discount is calculated.
       */
      if (retainCurrentPrice !== true) {
        renderNormalPrice(variant);
      }
      updateInventory(variant);

      if (updateImage === true) {
        updateCardImage(variant);
      }

      /*
       * WSAIO's output:false callbacks are synchronous on the live app.
       * Calculate in the same browser task so the normal intermediate
       * price cannot be painted before the Trade or multibuy price.
       */
      var activePriceRequestId = ++priceRequestId;

      applyWholesaleTierPrice(
        variant,
        activePriceRequestId
      );

      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      }
    }

    holder
      .querySelectorAll('.wwfs-direct-chip')
      .forEach(function (chip) {
        chip.addEventListener('click', function (event) {
          event.stopImmediatePropagation();

          var index = Number(
            chip.dataset.optionIndex
          );

          selected[index] = chip.dataset.value;

          if (!getVariant()) {
            var fallbackVariant =
              product.variants.find(function (variant) {
                return (
                  variant.options[index] === chip.dataset.value &&
                  variant.available
                );
              }) ||
              product.variants.find(function (variant) {
                return variant.options[index] === chip.dataset.value;
              });

            if (fallbackVariant) {
              selected = fallbackVariant.options.slice();
            }
          }

          syncActiveChips();

          /*
           * A customer actively selected an option,
           * so the product image may now change.
           */
          update(true);
        });
      });

    holder
      .querySelector('.wwfs-qty-minus')
      .addEventListener('click', function () {
        qtyInput.value = Math.max(
          1,
          Number(qtyInput.value || 1) - 1
        );

        update(false, true);
      });

    holder
      .querySelector('.wwfs-qty-plus')
      .addEventListener('click', function () {
        qtyInput.value =
          Number(qtyInput.value || 1) + 1;

        update(false, true);
      });

    qtyInput.addEventListener(
      'change',
      function () {
        qtyInput.value = Math.max(
          1,
          Math.floor(
            Number(qtyInput.value || 1)
          )
        );

        update(false, true);
      }
    );

    var addInProgress = false;
    var addButtonResetTimer = null;
    var requestedAddQuantity = 0;
    var submittedAddQuantity = 0;

    function resetAddButton() {
      if (addButtonResetTimer) {
        clearTimeout(addButtonResetTimer);
        addButtonResetTimer = null;
      }

      addInProgress = false;
      update(false);
    }

    function handleConfirmedAdd() {
      if (!addInProgress) return;

      addInProgress = false;

      if (
        requestedAddQuantity > submittedAddQuantity &&
        submittedAddQuantity > 0
      ) {
        addBtn.textContent =
          'Only ' +
          submittedAddQuantity +
          ' available — ' +
          submittedAddQuantity +
          ' added';

        qtyInput.value = submittedAddQuantity;
      } else {
        addBtn.textContent = 'Added ✓';
      }

      addButtonResetTimer = setTimeout(function () {
        addButtonResetTimer = null;
        update(false);
      }, 1400);
    }

    function getStockErrorMessage(errorText) {
      var message = String(errorText || '').toLowerCase();

      /*
       * Only describe an error as stock-related when Shopify's response
       * indicates an availability or quantity limit. Other errors retain
       * the general retry message.
       */
      var isStockError =
        message.indexOf('stock') !== -1 ||
        message.indexOf('inventory') !== -1 ||
        message.indexOf('not available') !== -1 ||
        message.indexOf('available quantity') !== -1 ||
        message.indexOf('cannot add more') !== -1 ||
        message.indexOf("can't add more") !== -1 ||
        /\ball\s+\d+\b.*\bin your cart\b/.test(message) ||
        /\bonly\s+\d+\b.*\bavailable\b/.test(message);

      if (!isStockError) return '';

      var variant = getVariant();
      var inventory = variant
        ? inventoryByVariant[String(variant.id)]
        : null;

      if (
        inventory &&
        inventory.management === 'shopify' &&
        inventory.policy !== 'continue' &&
        Number.isFinite(Number(inventory.quantity))
      ) {
        return (
          'Only ' +
          Math.max(0, Number(inventory.quantity)) +
          ' available'
        );
      }

      return 'Not enough stock available';
    }

    function handleAddError(event) {
      if (!addInProgress) return;

      var errorText =
        event.detail && event.detail.error
          ? String(event.detail.error)
          : '';

      addInProgress = false;
      addBtn.disabled = false;
      addBtn.textContent =
        getStockErrorMessage(errorText) ||
        'Couldn’t add – try again';

      if (errorText) {
        addBtn.setAttribute(
          'title',
          errorText
        );
      }

      addButtonResetTimer = setTimeout(function () {
        addButtonResetTimer = null;
        addBtn.removeAttribute('title');
        update(false);
      }, 3000);
    }

    if (nativeProductForm) {
      nativeProductForm.addEventListener(
        'on:cart:add',
        handleConfirmedAdd
      );

      nativeProductForm.addEventListener(
        'on:line-item:change',
        handleConfirmedAdd
      );

      nativeProductForm.addEventListener(
        'on:cart:error',
        handleAddError
      );
    }

    addBtn.addEventListener('click', function () {
      var variant = getVariant();

      var quantity = Math.max(
        1,
        Math.floor(Number(qtyInput.value || 1))
      );

      if (
        !variant ||
        !nativeForm ||
        !nativeProductForm ||
        addInProgress
      ) {
        return;
      }

      if (addButtonResetTimer) {
        clearTimeout(addButtonResetTimer);
        addButtonResetTimer = null;
      }

      addInProgress = true;
      requestedAddQuantity = quantity;
      submittedAddQuantity = quantity;

      var inventory =
        inventoryByVariant[String(variant.id)];

      if (
        inventory &&
        inventory.management === 'shopify' &&
        inventory.policy !== 'continue' &&
        Number.isFinite(Number(inventory.quantity))
      ) {
        submittedAddQuantity = Math.min(
          quantity,
          Math.max(0, Number(inventory.quantity))
        );
      }

      if (submittedAddQuantity < 1) {
        addInProgress = false;
        addBtn.disabled = false;
        addBtn.textContent = 'Out of stock';
        return;
      }

      addBtn.removeAttribute('title');
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      if (nativeVariantInput) {
        nativeVariantInput.value = variant.id;
      }

      if (nativeQtyInput) {
        nativeQtyInput.value = submittedAddQuantity;
      }

      if (nativeForm.requestSubmit) {
        nativeForm.requestSubmit(nativeSubmit);
      } else if (nativeSubmit) {
        nativeSubmit.click();
      } else {
        resetAddButton();
      }
    });

    /*
     * Initialise price, availability and the native form,
     * while retaining Shopify's main featured product image.
     */
    syncActiveChips();
    update(false);
  }

  function initWWFSCollectionCards() {
    registerCardImages(document);
    initWWFSCardActions();
    observeCollectionChanges();
    initFeefoCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initWWFSCollectionCards,
      { once: true }
    );
  } else {
    initWWFSCollectionCards();
  }

  document.addEventListener(
    'shopify:section:load',
    initWWFSCollectionCards
  );

})();

